import api from './api';

export const userService = {
  // Get user profile
  getProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  // Change password
  changePassword: async (passwordData) => {
    const response = await api.put('/users/password', passwordData);
    return response.data;
  },

  // Update ARN
  updateArn: async (arnData) => {
    const response = await api.put('/users/arn', arnData);
    return response.data;
  }
};